/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebneeddescription3Inputs */

const en_placewebneeddescription3 = /** @type {(inputs: Placewebneeddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The description needs at least 10 characters.`)
};

const de_placewebneeddescription3 = /** @type {(inputs: Placewebneeddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Beschreibung braucht mindestens 10 Zeichen.`)
};

/**
* | output |
* | --- |
* | "The description needs at least 10 characters." |
*
* @param {Placewebneeddescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebneeddescription3 = /** @type {((inputs?: Placewebneeddescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebneeddescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebneeddescription3(inputs)
	return de_placewebneeddescription3(inputs)
});
export { placewebneeddescription3 as "placeWebNeedDescription" }